import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GlobalState = {
  onCanvas: boolean;
};

const initialState: GlobalState = {
  onCanvas: false
};

const globalStateSlice = createSlice({
  name: 'globalState', 
  initialState,
  reducers: {
    setOnCanvas: (state, action: PayloadAction<boolean>) => {
      state.onCanvas = action.payload;
    }
  }
});

export const { setOnCanvas } = globalStateSlice.actions;

export default globalStateSlice.reducer;
